module.exports = __webpack_public_path__ + "static/media/request-physical-card-48x48.f17686ce.svg";